<template>
  <v-container>
    <v-row class="justify-center">
      <v-col cols="12" sm="10" md="8" lg="6">
        <v-card class="floor-plan-settings-card">
          <!-- Card Header with Gradient -->
          <div class="card-header-gradient">
            <v-icon size="64" color="white" class="mb-3">mdi-floor-plan</v-icon>
            <h2 class="white--text font-weight-bold mb-2">
              {{ $t('$vuetify.floorPlan.title') }}
            </h2>
          </div>

          <v-card-text class="pa-6">
            <p class="text-body-1 mb-6 description-text">
              {{ $t('$vuetify.floorPlan.settingsDescription') }}
            </p>

            <div class="text-center">
              <v-btn
                class="open-editor-btn"
                elevation="0"
                x-large
                @click="openFloorPlanEditor"
              >
                <v-icon left>mdi-pencil</v-icon>
                {{ $t('$vuetify.floorPlan.openEditor') }}
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Floor Plan Dialog -->
    <floor-plan-dialog
      ref="floorPlanDialog"
      :available-tables="tables"
    ></floor-plan-dialog>
  </v-container>
</template>

<script>
import FloorPlanDialog from '@/modules/cash-register/components/dialogs/FloorPlanDialog.vue'
import state from '@/state'
import { df } from '@/plugins/firebase'

export default {
  name: 'FloorPlanSettings',
  components: {
    FloorPlanDialog
  },
  data () {
    return {
      tables: []
    }
  },
  methods: {
    openFloorPlanEditor () {
      if (this.$refs.floorPlanDialog) {
        this.$refs.floorPlanDialog.open()
      }
    },
    async loadTables () {
      try {
        const pointOfSaleId = state.getPointOfSale().id
        const query = df.collection(`location_orders/${pointOfSaleId}/tables`).orderBy('number')
        const snapshot = await query.get()

        this.tables = []
        snapshot.docs.forEach((doc) => {
          this.tables.push(doc.data())
        })
      } catch (err) {
        console.error('Error loading tables:', err)
      }
    }
  },
  mounted () {
    this.loadTables()
  }
}
</script>

<style scoped>
/* Floor Plan Settings Card - Glass Style */
.floor-plan-settings-card {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px) !important;
  -webkit-backdrop-filter: blur(20px) !important;
  border-radius: 16px !important;
  border: 1px solid rgba(0, 179, 190, 0.2) !important;
  box-shadow: 0 8px 32px rgba(0, 179, 190, 0.12) !important;
  overflow: hidden !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.floor-plan-settings-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 48px rgba(0, 179, 190, 0.18) !important;
  border-color: rgba(0, 179, 190, 0.3) !important;
}

/* Card Header with Gradient Background */
.card-header-gradient {
  background: linear-gradient(135deg,
    rgba(0, 179, 190, 0.5) 0%,
    rgba(57, 137, 201, 0.45) 50%,
    rgba(97, 84, 164, 0.5) 100%) !important;
  padding: 48px 24px 32px;
  text-align: center;
  position: relative;
}

.card-header-gradient::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  opacity: 0.3;
  pointer-events: none;
}

.card-header-gradient h2 {
  font-size: 28px !important;
  letter-spacing: 0.5px !important;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  position: relative;
  z-index: 1;
}

.card-header-gradient .v-icon {
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.2));
  position: relative;
  z-index: 1;
}

/* Description Text */
.description-text {
  color: rgba(70, 70, 80, 0.9) !important;
  font-size: 16px !important;
  line-height: 1.6 !important;
  text-align: center;
  font-weight: 500 !important;
  letter-spacing: 0.3px !important;
}

/* Open Editor Button */
.open-editor-btn {
  background: rgba(255, 255, 255, 0.8) !important;
  color: #3989C9 !important;
  border-radius: 12px !important;
  border: 1px solid rgba(57, 137, 201, 0.15) !important;
  box-shadow: 0 2px 8px rgba(57, 137, 201, 0.15) !important;
  backdrop-filter: blur(10px) !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 16px !important;
  letter-spacing: 0.5px !important;
  padding: 0 32px !important;
  min-width: 240px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.open-editor-btn:hover {
  box-shadow: 0 4px 12px rgba(57, 137, 201, 0.25) !important;
  border-color: rgba(57, 137, 201, 0.3) !important;
  transform: translateY(-1px);
}

.open-editor-btn .v-icon {
  font-size: 20px !important;
  color: #3989C9 !important;
}
</style>
